export default "__VITE_ASSET__8joX1n4U__"